import React from 'react'
import { Popup } from 'devextreme-react/popup'
import './ICSModal.css'
import { ScrollView } from 'devextreme-react'

export const ICSModal = (
  props: React.PropsWithChildren<{
    id?: string,
    modalId?: string,
    visible: boolean
    onHiding: () => void
    dragEnabled?: boolean
    closeOnOutsideClick?: boolean
    defaultWidth?: number | string
    defaultHeight?: number | string
    title?: string
    shadingColor?: string
    position?: 'center' | 'bottom' | 'left' | 'right' | 'top' | any, //todo fix this
    offset?: string,
    resizeEnabled?: boolean
  }>
) => {
  const {
    id,
    modalId,
    visible,
    onHiding,
    dragEnabled = false,
    closeOnOutsideClick = true,
    title,
    defaultWidth = '30vw',
    defaultHeight = 'auto',
    position,
    offset,
    resizeEnabled
  } = props

  const modalProps = {
    id,
    modalId,
    visible,
    onHiding,
    dragEnabled,
    closeOnOutsideClick,
    title,
    defaultWidth,
    defaultHeight,
    showTitle: props.title?.length ? true : false,
    shadingColor: props.shadingColor ? props.shadingColor : '',
    position: position ? position : 'center',
    offset,
    resizeEnabled
  }

  return (
    <ScrollView height='100%' width='100%' id={props.id}>
      <Popup {...modalProps} id={props.modalId}>{props.children}</Popup>
    </ScrollView>
  )
}
